import React from "react";

const Index = ({
  handleClick,
  title = "Добавить",
  hasPlus = true,
  className,
}) => {
  return (
    <button
      type={"button"}
      className={
        className ? className : "d-btn d-btn--small fs-14 d-btn-primary"
      }
      onClick={() => handleClick()}
    >
      {title} {hasPlus && <span className="pl-10 fs-18">+</span>}
    </button>
  );
};

export default Index;
